import { Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { HorizontalRule } from "@mui/icons-material";


type DirectionalNumberProps = {
  number: number;
  infinity?: boolean;
};

const arrowStyle = { width: "14px", height: "14px", paddingTop: "5px" };

export function DirectionalNumber(props: DirectionalNumberProps) {
  var sign = <HorizontalRule sx={arrowStyle} />;
  var color = "black";
  if (props.number > 0) {
    color = "green";
    sign = <KeyboardArrowUpIcon sx={arrowStyle} />;
    if (props.number > 10) {
      sign = <KeyboardDoubleArrowUpIcon sx={arrowStyle} />;
    }
  }
  if (props.number < 0) {
    color = "red";
    sign = <KeyboardArrowDownIcon sx={arrowStyle} />;
    if (props.number < -10) {
      sign = <KeyboardDoubleArrowDownIcon sx={arrowStyle} />;
    }
  }
  return (
    <Typography variant="body1" color={color} align="right" textAlign={"right"} fontSize={"15px"}>
      {sign} 
      {props.infinity ? "∞" : Math.abs(props.number)}
    </Typography>
  );
}
